import { Link } from "react-router-dom";
import { Radar, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function DossierWatchReports({ did, reports, canEdit, onChange }) {
  if (!reports?.length) return null;
  const detach = async (rid) => { try { await api.delete(`/dossiers/${did}/attach-watch-report/${rid}`); toast.success("Rapport détaché"); onChange(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="panel p-4 space-y-2" data-testid="dossier-watch-reports">
      <div className="eyebrow flex items-center gap-1"><Radar size={12} />Rapports de veille joints ({reports.length}) — inclus dans le brouillon IA [V#] et les exports</div>
      {reports.map((r) => (
        <div key={r.id} className="border rounded p-3 text-xs space-y-1" data-testid={`dossier-watch-report-${r.id}`}>
          <div className="flex items-center gap-2"><Link to="/monitor" className="font-mono text-primary hover:underline">{r.reference}</Link>
            <span className="text-muted-foreground">{r.period.start.slice(0, 10)} → {r.period.end.slice(0, 10)} · {r.stats.valid} alertes valides</span>
            {canEdit && <button data-testid={`dossier-watch-report-detach-${r.id}`} onClick={() => detach(r.id)} title="Détacher" className="ml-auto text-muted-foreground hover:text-rose-500"><X size={13} /></button>}</div>
          <p className="text-sm line-clamp-3">{r.synthesis?.executive_summary || "Synthèse IA non générée."}</p>
        </div>))}
    </div>
  );
}
